import { render } from "./ErrorTraceback.vue?vue&type=template&id=bcb20050&scoped=true"
import script from "./ErrorTraceback.vue?vue&type=script&lang=js"
export * from "./ErrorTraceback.vue?vue&type=script&lang=js"

import "./ErrorTraceback.vue?vue&type=style&index=0&id=bcb20050&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb20050"]])

export default __exports__